export default {
  featuredExperiences: 'Experiențele Noastre Recomandate',
  searchAllExperiences: 'Caută toate Experiențele',
  searchAll: 'Caută Tot',
  groupSize: 'Dimensiune Grup',
  eventSize: 'Dimensiune Eveniment',
  upTo: 'Până la',
  whatWeDo: 'Ce Vom Face',
  hostedBy: 'Găzduit De',
  whatsIncluded: 'Ce Este Inclus',
  avail: 'Disponibilitate',
  whereWeAre: 'Unde Vom Fi',
  experienceCalendar: 'Calendar Experiențe',
  experienceCancelled: 'Experiență Anulată',
  experienceStartingPrice: 'De la {{price}}',
  experienceTotalPrice: 'Total {{price}}',
  at: 'la',
  viewPrivateSessAvailability: 'Vezi disponibilitatea sesiunilor private',
  selectDuration: 'Durată',
  selectStartTime: 'Ora de început',
  selectSession: 'Selectează Sesiunea',
  sessionsCount: '{{count}} ore — alegeți o oră',
  noAvailability: 'Fără Disponibilitate',
  select: 'Selectează',
  slotLeft: '{{remainSlots}} loc rămas',
  slotsLeft: '{{remainSlots}} locuri rămase',
  spotsLeft: '{{count}} rămase',
  spotsLeftAriaLabel: '{{count}} locuri rămase',
  bookExperience: 'Rezervă Experiența',
  book: 'Rezervă',
  learnMore: 'Află mai multe',
  apply: 'Aplică',
  maxPartySizes: 'Maxim {{maxGroupSize}} locuri per grup',
  maxPartySize: 'Maxim {{maxGroupSize}} loc per grup',
  selectSessionValidation: 'Vă rugăm să selectați sesiunea',
  selectParticipantValidation: 'Vă rugăm să selectați participanții',
  selectDateValidation: 'Vă rugăm să selectați data',
  reminders: 'Memento-uri',
  seeOtherDates: 'Vezi alte date',
  location: 'Locație',
  about: 'Despre',
  allExperiences: 'Toate experiențele',
  soldOut: 'Epuizat',
  addOns: 'Suplimente',
  reviews: 'Recenzii',
  reviewSingular: 'recenzie',
  reviewPlural: 'recenzii',
  dateOfExperience: 'Data experienței',
  readLess: 'Citește Mai Puțin',
  readMore: 'Citește Mai Mult',
  seeMore: 'Vezi Mai Mult',
  details: 'Detalii',
  durationHour: 'oră',
  durationHours: 'ore',
  durationMinutes: 'min',
  theFollowingVideoDoesNotContainAnyAudio:
    'Următorul videoclip nu conține audio',
  by: 'De',
  chooseATime: 'Alegeți o oră pentru {{title}}',
  amenities: 'Facilități',
  ticketSalesOpenIn: 'Vânzarea biletelor se deschide în',
  ticketSalesOpen: 'Vânzarea biletelor este deschisă',
  ticketSalesCloseIn: 'Vânzarea biletelor se închide în',
  ticketSalesClose: 'Vânzarea biletelor se închide',
  ticketSalesClosed: 'Vânzarea biletelor s-a închis',
  comingSoon: 'În curând',
  inPartnershipWith: 'În parteneriat cu',
  notFoundExperienceTitle: 'Această experiență nu mai este disponibilă',
  notFoundExperienceSubtitle:
    'Este posibil să fi fost depublicată sau linkul să nu mai fie valid.',
  deadLinkRecoverySubtitle:
    'Descoperă alte experiențe disponibile pentru rezervare',
  viewAllExperiences: 'Vezi Toate Experiențele',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>Câștigă 5 Puncte de Bază</strong> per $1 USD eligibil cheltuit când te conectezi la contul tău World of Hyatt pentru a rezerva această experiență</p>',
      basePoints:
        '<p><strong>Câștigă 10 Puncte de Bază</strong> per $1 USD eligibil cheltuit când te conectezi la contul tău World of Hyatt pentru a rezerva această experiență</p>',
      additionalBonusPoints:
        '<p><strong>Câștigă 4 Puncte Bonus suplimentare</strong> per $1 USD eligibil cheltuit când rezervi cu Cardul de Credit World of Hyatt</p>',
      additionalBonusPointsTier:
        '<p><strong>Câștigă până la 30% Puncte Bonus suplimentare</strong> în funcție de statusul nivelului tău</p>',
      payWithPoints:
        '<p><strong>Plătește cu Puncte</strong> când rezervi această experiență</p>',
    },
  },
};
